module.exports = __webpack_public_path__ + "static/media/about3.2cc2b660.jpg";